import { BreakpointState } from '@angular/cdk/layout';
import { Injectable } from '@angular/core';

import { MediaQueryService } from '@frontend/vanilla/core';
import { isEqual } from 'lodash-es';
import { Observable, ReplaySubject, distinctUntilChanged } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PatchedMediaObserver extends MediaQueryService {
    private layout = new ReplaySubject<BreakpointState>(1);

    constructor() {
        super();

        super.observe().pipe(distinctUntilChanged(isEqual)).subscribe(this.layout);
    }

    override observe(): Observable<BreakpointState> {
        return this.layout.asObservable();
    }
}
